module.exports = __webpack_public_path__ + "img/SUSHI.14274fb8.svg";